import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

export const uploadFiles = async (files, folder) => {
  const urls = [];
  const wsId = "ai-apps-dashboard"; // workspace ID

  for (const file of files) {
    const fileRef = ref(
      storage,
      `workspaces/${wsId}/projects/${folder}/${Date.now()}_${file.name}`
    );

    await uploadBytes(fileRef, file);
    const url = await getDownloadURL(fileRef);
    urls.push(url);
  }

  return urls;
};

